/*
 * Copyright (c) 2025 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Maybe } from '@irian-ro/util-functions';
import { PackageUtils } from '@well/packages/util';
import { ShipmentRequestDtoModel } from './shipment-request-dto.model';

export interface ShipmentContractFilters {
  pickupCity: Maybe<string>;
  deliveryCity: Maybe<string>;
  packageWeight: Maybe<string>;
  tags: Maybe<string[]>;
}

export function contractFiltersFromShipment(shipment: ShipmentRequestDtoModel | null): ShipmentContractFilters {
  const groupedPackages = PackageUtils.getGroupedPackagesDtos(shipment?.packages || []);
  const totalWeight = shipment?.packages.reduce((sum, { weight = 0 }) => sum + (weight || 0), 0);

  return {
    pickupCity: shipment?.pickup?.address?.city || null,
    deliveryCity: shipment?.delivery?.address?.city || null,
    packageWeight: totalWeight?.toString() || null,
    tags: groupedPackages.flatMap((pkg) => pkg.tags || []),
  };
}
